import React from 'react';
import { connect } from 'react-redux';

import { cartRemoveItem, cartInfoUpdate, loadCartInformation } from '../../../actions/cart';
import deleteIcon from '../../../assets/images/delete.svg';
import deleteXIcon from '../../../assets/images/delete-icon-checkout.svg';
// import Delete from '../../assets/svg/Delete';
// import CloseIconRed from '../../assets/svg/CloseIconRed';

class CartIndividualItem extends React.Component {

    constructor(props) {
        super(props);
        this.removeCartItem = this.removeCartItem.bind(this);
    }

    printToppingPortion(theCartTopping) {
        if (theCartTopping.portion == "H1") {
            return " (First Half Only)";
        }
        else if (theCartTopping.portion == "H2") {
            return " (Second Half Only)";
        }
        else {
            return "";
        }
    };

    printItemPrice(theItem, price_id) {

        let printPrice = "";
        theItem.prices.forEach((thePrice) => {
            if (thePrice.size_id == price_id && thePrice.price > 0) {
                printPrice = " - "+thePrice.price;
            }
        })

        return printPrice;
    };

    printChoicePrice(theChoice, isMultiple = false) {
        let thePrice = 0.00;
        if (isMultiple) {
            thePrice = parseFloat(theChoice.price);
        }
        else {
            thePrice = parseFloat(theChoice.item_price);
        }

        if (thePrice > 0) {
            return " - "+thePrice.toFixed(2);
        }
        else {
            return "";
        }
    };

    printPrice(theAddon) {

        const thePrice = parseFloat(theAddon.price);

        if (theAddon.price > 0) {
            return " - "+thePrice.toFixed(2);
        }
        else {
            return "";
        }
    };

    removeCartItem(scope, index) {

        if (this.props.isCheckout) {

            // set the submit order screen to loading
            this.props.dispatch(cartInfoUpdate({ prop: 'loading', value: true }));

            // remove the cart item
            this.props.dispatch(cartRemoveItem(scope, index));

            // make a copy of the cart and remove it from there
            let theCart = {
                ...this.props.cart,
                items: {
                    ...this.props.cart.items,
                    [scope+"s"]: this.props.cart.items[scope+"s"].filter((theItem, theIndex) => {
                        return theIndex != index;
                    })
                }
            };

            this.props.dispatch(loadCartInformation(this.props.loggedUser.uid, this.props.currentLocation, theCart, null, this.props.token, false));
        }
        else {
            this.props.dispatch(cartRemoveItem(scope, index));
        }
    }

    getItemDetails(theCartType, theCartItem) {

        let theDetails = [];
    
        // determine what the item is so we can begin making the details
        switch(theCartType) {
    
            case "pizza":
    
                if (theCartItem.pizzatype == "custom") {
    
                    theCartItem.toppings.forEach((theCartTopping) => {
                        this.props.currentLocation.toppings.forEach((theTopping) => {
                            if (theCartTopping.id == theTopping.id) {
                                theDetails.push(theTopping.name+this.printToppingPortion(theCartTopping));
                            }
                        });
                    });
    
                    if (theCartItem.crust_id > 0) {
                        this.props.currentLocation.customCrusts.forEach((theCrust) => {
                            if (theCrust.id == theCartItem.crust_id) {
                                theDetails.push("Crust: "+theCrust.name+this.printItemPrice(theCrust, theCartItem.price_id));
                            }
                        });
                    }
    
                    // get the sauce details
                    if (theCartItem.sauce_id > 0) {
                        this.props.currentLocation.customSauces.forEach((theSauce) => {
                            if (theSauce.id == theCartItem.sauce_id) {
                                theDetails.push("Sauce: "+theSauce.name+this.printItemPrice(theSauce, theCartItem.price_id));
                            }
                        });
                    }
                }
                else {
                    if (this.props.currentLocation.pizzas) {
                        // get the pizza from the menu
                        const matchingPizzas = this.props.currentLocation.pizzas.filter((thePizza) => thePizza.id == theCartItem.item_id);
                        const thePizza = matchingPizzas[0];
    
                        // get the topping details
                        theCartItem.toppings.forEach((theCartTopping) => {
                            if (!theCartTopping.isdefault || (theCartTopping.isdefault && (theCartTopping.amount != "include" || theCartTopping.portion != 'W'))) {
        
                                thePizza.toppings.forEach((theTopping) => {
                                    if (theTopping.id == theCartTopping.id) {
        
                                        if (theCartTopping.amount == "extra") {
                                            theDetails.push("Extra "+theTopping.name+this.printToppingPortion(theCartTopping)+this.printItemPrice(theTopping, theCartItem.price_id));
                                        }
                                        else if (theCartTopping.isdefault && theCartTopping.amount == "none") {
                                            theDetails.push("No "+theTopping.name+this.printToppingPortion(theCartTopping));
                                        }
                                        else if (!theCartTopping.isdefault && theCartTopping.amount == "include") {
                                            theDetails.push("Add "+theTopping.name+this.printToppingPortion(theCartTopping)+this.printItemPrice(theTopping, theCartItem.price_id));
                                        }
                                        else if (theCartTopping.isdefault && theCartTopping.portion != "W") {
                                            theDetails.push("Include "+theTopping.name+this.printToppingPortion(theCartTopping));
                                        }
                                    }
                                });
                            }
                        });
        
                        // get the crust details
                        if (theCartItem.crust_id > 0) {
                            thePizza.crusts.forEach((theCrust) => {
                                if (theCrust.id == theCartItem.crust_id) {
                                    theDetails.push("Crust: "+theCrust.name+this.printItemPrice(theCrust, theCartItem.price_id));
                                }
                            });
                        }
        
                        // get the sauce details
                        if (theCartItem.sauce_id > 0) {
                            thePizza.sauces.forEach((theSauce) => {
                                if (theSauce.id == theCartItem.sauce_id) {
                                    theDetails.push("Sauce: "+theSauce.name+this.printItemPrice(theSauce, theCartItem.price_id));
                                }
                            });
                        }
                    }
                }
                break;
    
            case "fooditem":
    
                // get the food item from the menu
                let matchingFoodItems = [],
                    theFoodItem = {};

                if (this.props.currentLocation.fooditems) {
                    Object.keys(this.props.currentLocation.fooditems).forEach((theCategoryItemKey) => {
                        matchingFoodItems = this.props.currentLocation.fooditems[theCategoryItemKey].filter((theFoodItem) => theFoodItem.id == theCartItem.item_id);
        
                        if (matchingFoodItems.length > 0) {
                            theFoodItem = matchingFoodItems[0];
                        }
                    });
                }
    
                // get the choice details
                theCartItem.choices.forEach((theCartChoice) => {
    
                    if (theCartChoice.is_multiple) {
    
                        theFoodItem.choices.forEach((theChoice) => {
                            if (theChoice.id == theCartChoice.id) {
    
                                theCartChoice.items.forEach((theCartChoiceItem) => {
                                    theChoice.items.forEach((theChoiceItem) => {
                                        if (theChoiceItem.id == theCartChoiceItem) {
                                            theDetails.push(theChoiceItem.name+this.printChoicePrice(theChoiceItem, true));
                                        }
                                    });
                                });
                                
                            }
                        });
                    }
                    else {
                        theDetails.push(theCartChoice.item_name+this.printChoicePrice(theCartChoice, false));
                    }
                        
                });

                // get modifier details
                theCartItem.modifiers.forEach((foodItemModifier) => {
                    foodItemModifier.items.forEach((item) => {
                        let price = parseFloat(item.price);
                        price = price > 0 ? " - " + price.toFixed(2) : "";
                        theDetails.push(item.name + price);
                    });
                });
                
    
                // get the addon details
                theCartItem.addons.forEach((theCartAddon) => {
                    theFoodItem.addons.forEach((theAddon) => {
                        if (theCartAddon == theAddon.id) {
                            theDetails.push(theAddon.name+this.printPrice(theAddon, theCartAddon));
                        }
                    });
                });
                break;
    
            case "special":
    
                if (this.props.currentLocation.specials) {

                    // get the pizza from the menu
                    const matchingSpecials = this.props.currentLocation.specials.filter((theSpecial) => theSpecial.id == theCartItem.item_id);
                    const theSpecial = matchingSpecials[0];
        
                    // get the individual item details
                    theCartItem.items.forEach((theCartSpecialItem, theCartSpecialItemIndex) => {
                        theDetails.push(theCartSpecialItem.display_name);
                        let theSpecialItem = {};
        
                        theSpecial.items.forEach((theSpecialItemChoices) => {
                            theSpecialItemChoices.choices.forEach((theSpecialItemChoice) => {
                                if (theSpecialItemChoice.id == theCartSpecialItem.choice_id) {
                                    theSpecialItem = theSpecialItemChoice;
                                }
                            });
                        });
        
                        switch(theCartSpecialItem.type) {
        
                            case "pizza":
        
                                theCartSpecialItem.toppings.forEach((theCartTopping) => {
                                    if (!theCartTopping.isdefault || (theCartTopping.isdefault && (theCartTopping.amount != "include" || theCartTopping.portion != 'W'))) {
            
                                        theSpecialItem.toppings.forEach((theTopping) => {
                                            if (theTopping.id == theCartTopping.id) {
            
                                                if (theCartTopping.amount == "extra") {
                                                    theDetails.push("-- Extra "+theTopping.name+this.printToppingPortion(theCartTopping)+this.printPrice(theTopping));
                                                }
                                                else if (theCartTopping.isdefault && theCartTopping.amount == "none") {
                                                    theDetails.push("-- No "+theTopping.name+this.printToppingPortion(theCartTopping));
                                                }
                                                else if (!theCartTopping.isdefault && theCartTopping.amount == "include") {
                                                    theDetails.push("-- Add "+theTopping.name+this.printToppingPortion(theCartTopping)+this.printPrice(theTopping));
                                                }
                                                else if (theCartTopping.isdefault && theCartTopping.portion != "W") {
                                                    theDetails.push("-- Include "+theTopping.name+this.printToppingPortion(theCartTopping));
                                                }
                                            }
                                        });
                                    }
                                });
            
                                // get the crust details
                                if (theCartSpecialItem.crust_id > 0) {
                                    theSpecialItem.crusts.forEach((theCrust) => {
                                        if (theCrust.id == theCartSpecialItem.crust_id) {
                                            theDetails.push("-- Crust: "+theCrust.name+this.printPrice(theCrust));
                                        }
                                    });
                                }
            
                                // get the sauce details
                                if (theCartSpecialItem.sauce_id > 0) {
                                    theSpecialItem.sauces.forEach((theSauce) => {
                                        if (theSauce.id == theCartSpecialItem.sauce_id) {
                                            theDetails.push("-- Sauce: "+theSauce.name+this.printPrice(theSauce));
                                        }
                                    });
                                }
                                break;
        
                            case "custompizza":
        
                                theCartSpecialItem.toppings.forEach((theCartTopping) => {
                                    this.props.currentLocation.toppings.forEach((theTopping) => {
                                        if (theCartTopping.id == theTopping.id) {
                                            theDetails.push("-- "+theTopping.name+this.printToppingPortion(theCartTopping));
                                        }
                                    });
                                });
            
                                if (theCartSpecialItem.crust_id > 0) {
                                    theSpecialItem.crusts.forEach((theCrust) => {
                                        if (theCrust.id == theCartSpecialItem.crust_id) {
                                            theDetails.push("-- Crust: "+theCrust.name+this.printPrice(theCrust));
                                        }
                                    });
                                }
            
                                // get the sauce details
                                if (theCartSpecialItem.sauce_id > 0) {
                                    theSpecialItem.sauces.forEach((theSauce) => {
                                        if (theSauce.id == theCartSpecialItem.sauce_id) {
                                            theDetails.push("-- Sauce: "+theSauce.name+this.printPrice(theSauce));
                                        }
                                    });
                                }
                                break;
        
                            case "fooditem":
        
                                // get the choice details
                                theCartSpecialItem.choices.forEach((theCartChoice) => {
        
                                    if (theCartChoice.is_multiple) {
        
                                        theSpecialItem.fooditem.choices.forEach((theChoice) => {
                                            if (theChoice.id == theCartChoice.id) {
        
                                                theCartChoice.items.forEach((theCartChoiceItem) => {
                                                    theChoice.selections.forEach((theChoiceItem) => {
                                                        if (theChoiceItem.id == theCartChoiceItem) {
                                                            theDetails.push("-- "+theChoiceItem.name+this.printChoicePrice(theChoiceItem, true));
                                                        }
                                                    });
                                                });
                                                
                                            }
                                        });
                                    }
                                    else {
                                        theDetails.push("-- "+theCartChoice.item_name+this.printChoicePrice(theCartChoice, false));
                                    }
                                        
                                });
        
                                // get the addon details
                                theCartSpecialItem.addons.forEach((theCartAddon) => {
                                    theSpecialItem.fooditem.addons.forEach((theAddon) => {
                                        if (theCartAddon == theAddon.id) {
                                            theDetails.push("-- "+theAddon.name+this.printPrice(theAddon, theCartAddon));
                                        }
                                    });
                                });
        
                                break;
                        }
                    });
                }
    
                break;
    
            case "beverage":
            case "addon":
                break;
        }
    
        // add the instructions
        if (theCartItem.instructions && theCartItem.instructions.trim() != "") {
            theDetails.push("Instructions: "+theCartItem.instructions);
        }
    
        return theDetails;
    }
    
    getItemName(theCartType, theCartItem) {
    
        let theItemName = "";
    
        // determine what the item is so we can begin making the details
        switch(theCartType) {
    
            case "pizza":
    
                if (theCartItem.pizzatype == "custom") {
                    return theCartItem.price_name+" "+theCartItem.max_toppings+" Topping Pizza";
                }
                else {
                    if (this.props.currentLocation.pizzas) {
                        // get the pizza from the menu
                        const matchingPizzas = this.props.currentLocation.pizzas.filter((thePizza) => thePizza.id == theCartItem.item_id);
                        const thePizza = matchingPizzas[0];
                        let pizzaName = theCartItem.price_name+" "+thePizza.name;
        
                        if (!pizzaName.match(/pizza\s*$/i)) {
                            pizzaName = pizzaName.trim()+" Pizza";
                        }
        
                        return pizzaName;
                    }
                }
    
            case "fooditem":
    
                // get the food item from the menu
                let matchingFoodItems = [],
                    theFoodItem = {},
                    foodName = "";
                  
                if (this.props.currentLocation.fooditems) {
                    Object.keys(this.props.currentLocation.fooditems).forEach((theCategoryItemKey) => {
                        matchingFoodItems = this.props.currentLocation.fooditems[theCategoryItemKey].filter((theFoodItem) => theFoodItem.id == theCartItem.item_id);
        
                        if (matchingFoodItems.length > 0) {
                            theFoodItem = matchingFoodItems[0];
                        }
                    });
                }
    
                if (theCartItem.price_name != '<default>') {
                    foodName = theCartItem.price_name + " ";
                }
                foodName += theFoodItem.name;
                return foodName;
    
            case "special":
    
                if (this.props.currentLocation.specials) {
                    // get the pizza from the menu
                    const matchingSpecials = this.props.currentLocation.specials.filter((theSpecial) => theSpecial.id == theCartItem.item_id);
                    const theSpecial = matchingSpecials[0];
                    return theSpecial.name;
                }

                return '';
    
            case "beverage":
    
                const matchingBeverages = this.props.currentLocation.beverages.filter((theBeverage) => theBeverage.id == theCartItem.item_id);
                const theBeverage = matchingBeverages[0];
                let beverageName = "";
    
                if (theCartItem.price_name != '<default>') {
                    beverageName = theCartItem.price_name + " ";
                }
                beverageName += theBeverage.name;
                return beverageName;
    
            case "addon":
                return theCartItem.name;
        }
    
        return theItemName;
    }

    render() {
        const { scope, index, item } = this.props;
        const itemDetails = this.getItemDetails(scope, item);

        return (
            <div>
                { (this.props.isCheckout) ? (

                    <div>

                    <div>
                        <div className="order-item extra-items">
                            <div className="close-icon w-inline-block"
                                onClick={() => {
                                    this.removeCartItem(scope, index);
                                 }}
                            >
                                <img src={deleteXIcon} className="delete-item"/>
                            </div>
                            <div className="checkout-food-title-name">{item.quantity} x {this.getItemName(scope, item)}</div>
                            <div className="bolded-price">${parseFloat(item.total_item_price).toFixed(2)}</div>
                            
                            
                        </div>
                        <div className="extra-items-margin">
                    
                        {itemDetails.map((theDetail, theDetailIndex) => {
                                        return (
                                            <p key={"item-"+index+"-"+theDetailIndex} className="extra-item">{theDetail}</p>
                                        );
                                    })}
                    </div>
                    </div>

                      
                   

   

                </div>


                ): (
                    
                        <div className="horizontal-cart-individual-padding">
                            <div className="order-item-wrapper">
                                <div className="order-info w-inline-block">
                                    <div className="order-title">
                                        {item.quantity} x {this.getItemName(scope, item)}
                                    </div>

                                    <div className="order-title price-div">
                                        ${parseFloat(item.total_item_price).toFixed(2)}
                                    </div>
                                    {itemDetails.map((theDetail, theDetailIndex) => {
                                      return (
                                          <p key={"item-"+index+"-"+theDetailIndex} className="checkout-card-details">- {theDetail}</p>
                                      );
                                  })}
                                </div>
                                <div className="repeat-div" onClick={() => {
                                      this.removeCartItem(scope, index);
                                  }}>
                                    <img src={deleteIcon} className="trash-can"/>
                                </div>
                            </div>
                     
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
      token: state.auth.token,
      currentLocation: state.currentLocation.info,
      cart: state.cart,
      loggedUser: state.auth.user,
    };
  };

export default connect(mapStateToProps)(CartIndividualItem);